// @ts-nocheck
 
 
 
 
 
/* eslint-disable padding-line-between-statements, import/order, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars, react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps, @typescript-eslint/no-use-before-define, import/no-extraneous-dependencies */
 
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
 
 
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useIntl } from 'react-intl';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import { useTypedSelector } from 'helpers';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton } from '@material-ui/core';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { TableLimitPaginationFilter } from './view-fareMedia-transactions/aboveTableFunctions/tableLimitPaginationFilter';
import { TableStatistics } from './view-fareMedia-transactions/aboveTableFunctions/tableStatistics';
import { TransactionTabs } from './view-fareMedia-transactions/transactionTabs';
import { TableFilter } from './view-fareMedia-transactions/aboveTableFunctions/tableFilter';
import { TicketsTranscTable } from './view-fareMedia-transactions/ticketsTranscTable';
import { ChargingTranscTable } from './view-fareMedia-transactions/chargingTranscTable';
import { BothTranscTable } from './view-fareMedia-transactions/bothTranscTable';
import { FmSellingTable } from './view-fareMedia-transactions/fmSellingTable';
import { FmOffersTable } from './view-fareMedia-transactions/fmOffersTable';

import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import PaidIcon from '@mui/icons-material/Paid';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

const ViewFareMedia = () => {

  const { id } = useParams();
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
  const intl = useIntl();
  const history = useHistory();


  const [fareMediaData, setFareMediaData] = useState(null);


  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(true);
  const [error, setError] = useState(null);
  //displaying transactions
  const [page, setPage] = useState<any>(1);
  const [limit, setLimit] = useState<any>(10);
  const [isFilterClicked, setIsFilterClicked] = useState<any>(0);
  //res
  const [transactions, setTransactions] = useState<any[]>([]);
  const [pageCount, setPageCount] = useState<any>(0);
  const [transactionsTotalAmount, setTransactionsTotalAmount] = useState(null);
  const [transactionsNumber, setTransactionsNumber] = useState(null);
  const [transactionsTotalCredits, setTransactionsTotalCredits] = useState(null);
  const [transactionsTotalDebits, setTransactionsTotalDebits] = useState(null);
  const [displayedTotalAmount, setDisplayedTotalAmount] = useState(null);
  const [displayedTotalCredits, setDisplayedTotalCredits] = useState(null);
  const [displayedTotalDebits, setDisplayedTotalDebits] = useState(null);
  //datetime handle 
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [filterStartDateValue, setFilterStartDateValue] = useState(null);
  const [filterEndDateValue, setFilterEndDateValue] = useState(null);
  // const [fareMediaInfo, setFareMediaInfo] = useState(null);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tabNames = ['all', 'tickets', 'charging', 'eligibility', 'history', 'selling', 'offers'];
  const tabQuery = query.get('tab');
  const initialTab = tabQuery ? tabNames.indexOf(tabQuery) : 0;
  const initialValidTab = initialTab !== -1 ? initialTab : 0;

  const getBaseUrlForTab = (tabVal) => {
    if (tabVal == 0) return `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/transactions/account_statement`;
    if (tabVal == 1) return `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/transactions/get_pay_ticket_transactions_for_one_fare_media`;
    if (tabVal == 2) return `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/transactions/get_charging_transactions_for_one_fare_media`;
    if (tabVal == 3) return `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/fare_media_eligibility`;
    if (tabVal == 5) return `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/fare-media/selling/get_selling_logs_for_fm`;
    if (tabVal == 6) return `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/fare_product_instances`;
    return `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/transactions/account_statement`;
  };

  const [transactionsBaseUrl, setTransactionsBaseUrl] = useState(getBaseUrlForTab(initialValidTab));
  const [tabsValue, setTabsValue] = React.useState(initialValidTab);
  //
  let userPersonalData = '';
  let userAuthData = '';
  const authData = localStorage.getItem('authData');

  if (authData !== null) {
    const parsedAuthData = JSON.parse(authData);
    userPersonalData = parsedAuthData.userData;
    userAuthData = parsedAuthData.userToken;
  }
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    const newTabName = tabNames[newValue] || 'all';
    history.replace({ search: `?tab=${newTabName}` });

    // 0 -> both
    // 1 -> tickets
    // 2 -> charging
    if (newValue == 0) {
      setTransactionsBaseUrl(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/transactions/account_statement`)
    } else if (newValue == 1) {
      setTransactionsBaseUrl(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/transactions/get_pay_ticket_transactions_for_one_fare_media`)
    } else if (newValue == 2) {
      setTransactionsBaseUrl(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/transactions/get_charging_transactions_for_one_fare_media`)
    } else if (newValue == 3) {
      setTransactionsBaseUrl(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/fare_media_eligibility`)
    } else if (newValue == 5) {
      setTransactionsBaseUrl(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/fare-media/selling/get_selling_logs_for_fm`)
    } else if (newValue == 6) {
      setTransactionsBaseUrl(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/fare_product_instances`)
    }
    setTabsValue(newValue);
    setPage(1);
    setIsFilterClicked(0);
    setTransactions([])
    setPageCount(0)
    setIsLoading(false);
    setLimit(10)
    setTransactionsNumber(null)
    setTransactionsTotalAmount(null)
    setTransactionsTotalCredits(null)
    setTransactionsTotalDebits(null)
    setDisplayedTotalAmount(null)
    setDisplayedTotalCredits(null)
    setDisplayedTotalDebits(null)
    setFilterStartDateValue(null)
    setFilterEndDateValue(null)
  };

  function handlePrevious() {

    setPage((p) => {
      if (p === 1) return p;
      return p - 1;
    });
  }
  function handleNext() {

    setPage((p) => {
      if (p === pageCount) return p;
      return p + 1;
    });
  }
  function handleChangeLimit(lim) {

    setLimit(lim);
    setPage(1)
  }
  function convertToFormattedUTC(utcDateString) {
    const date = new Date(utcDateString);
    const options = { timeZone: 'UTC' };
    //return date.toLocaleString('en-US', options); // Formats the UTC date
    return moment(date.toLocaleString('en-US', options)).format('DD/MM/YYYY HH:mm:ss');
  }

  const runDateTimeFilter = (e) => {
    e.preventDefault();

    const formattedStartDate = format(startDate, 'MM/dd/yyyy, hh:mm:ss a');
    const formattedEndDate = format(endDate, 'MM/dd/yyyy, hh:mm:ss a');

    setFilterStartDateValue(formattedStartDate)
    setFilterEndDateValue(formattedEndDate)
    setPage(1)
    setIsFilterClicked(1);
    handleClose();
  };
  const clearFilterResultOnly = () => {
    setPage(1);
    setIsFilterClicked(0);
    setFilterStartDateValue(null)
    setFilterEndDateValue(null)
    setStartDate(new Date())
    setEndDate(new Date())
  };
  //handle filteration part
  const [anchorEl, setAnchorEl] = React.useState(null);
  const filterPopoverClickButton = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const idOfPopUp = open ? 'simple-popover' : undefined;
  const HandleMessage = (msg, type) => {
    if (type === "warn")
      toast.warn(msg)
    else if (type === "success")
      toast.success(msg)
    else if (type === "error")
      toast.error(msg)
  };



  const fetchTransactions = (serial_num, uid) => {
    let url = (`${transactionsBaseUrl}?page=${page}&pageSize=${limit}`)
    setIsLoading(true)
    // alert(fareMediaData.serial_num);
    let promise;
    if (tabsValue === 3) {
      promise = axios.get(`${transactionsBaseUrl}?fare_media_id=${id}&page=${page}&pageSize=${limit}`, {
        headers: {
          'access-token': userAuthData['access-token'],
          'uid': userAuthData.uid,
          'client': userAuthData.client
        }
      });
    } else if (tabsValue === 6) {
      promise = axios.get(`${transactionsBaseUrl}/${id}`, {
        headers: {
          'access-token': userAuthData['access-token'],
          'uid': userAuthData.uid,
          'client': userAuthData.client
        }
      });
    } else {
      let postBody = {};
      if (tabsValue === 0) {
        postBody = {
          fare_media_uid: uid,
          startDate: filterStartDateValue,
          endDate: filterEndDateValue
        }
      } else if (tabsValue === 4 || tabsValue === 5) {
        postBody = {
          fare_media_id: id
        }
      } else {
        postBody = {
          fare_media_serial: serial_num,
          startDate: filterStartDateValue,
          endDate: filterEndDateValue
        }
      }

      promise = axios.post(url, postBody, {
        headers: {
          'access-token': userAuthData['access-token'],
          'uid': userAuthData.uid,
          'client': userAuthData.client
        }
      });
    }

    promise
      .then((res) => {
        let resultsArray = res.data.data.result;
        let paginationInfo = res.data.data;
        if (tabsValue === 3) {
           resultsArray = res.data.data.fareMediaEligibility;
           paginationInfo = res.data.data.pagination;
        } else if (tabsValue === 4) {
           resultsArray = res.data.data.history;
           paginationInfo = res.data.data.pagination;
        } else if (tabsValue === 5) {
           // Selling endpoint returns { result, totalCount, totalPages, currentPage } directly under data
           resultsArray = res.data.data.result;
           paginationInfo = res.data.data;
        } else if (tabsValue === 6) {
           resultsArray = res.data.data;
           paginationInfo = { totalPages: 1, totalCount: resultsArray.length || 0 };
        }

        setTransactions(resultsArray || [])
        setPageCount(paginationInfo.totalPages || 0)
        setIsLoading(false);
        setTransactionsNumber(paginationInfo.totalCount || 0)
        
        if (tabsValue < 3) {
          setTransactionsTotalAmount(res.data.data.totalAmount)
          setTransactionsTotalCredits(res.data.data.totalCredits)
          setTransactionsTotalDebits(res.data.data.totalDebits)
          setDisplayedTotalAmount(res.data.data.displayedTotalAmount)
          setDisplayedTotalCredits(res.data.data.displayedTotalCredits)
          setDisplayedTotalDebits(res.data.data.displayedTotalDebits)
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.data && error.response.data.message) {
          HandleMessage(` ${error.response.data.message}`, "error")
        } else {
          HandleMessage(`${error}`, "error")
        }
        setTransactions([])
        setTransactionsNumber(null)
        setTransactionsTotalAmount(null)
        setTransactionsTotalCredits(null)
        setTransactionsTotalDebits(null)
        setDisplayedTotalAmount(null)
        setDisplayedTotalCredits(null)
        setDisplayedTotalDebits(null)
        setIsLoading(false);
      })
  }


  const fetchFareMedia = async () => {
    setIsFormLoading(true);
    setError(null);
    try {
      const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_fare_media`;
      const response = await axios.post(
        url,
        { fare_media_id: id },
        {
          headers: {
            'access-token': userAuthData?.access_token,
            uid: userAuthData?.uid,
            client: userAuthData?.client,
          },
        }
      );

      setFareMediaData(response.data.data)
      fetchTransactions(response.data.data.serial_num, response.data.data.uid);


    } catch (error) {
      setError(`Failed to fetch fare_media [${error}]`);
      toast.error(`Failed to fetch fare_media [${error}]`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
      });
    } finally {
      setIsFormLoading(false);
    }
  };


  useEffect(() => {
    fetchFareMedia();
  }, []);
  useEffect(() => {
    fareMediaData && fareMediaData.serial_num && fareMediaData.uid && fetchTransactions(fareMediaData.serial_num, fareMediaData.uid);
  }, [page, limit, filterStartDateValue, filterEndDateValue, transactionsBaseUrl])

  const hasWriteAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'FareMedia')
  );
  function convertToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    // return date.toLocaleString(); // Converts to local time and formats it
    return moment(date.toLocaleString()).format('DD/MM/YYYY HH:mm:ss');
  }


  return (
    <>
      <Box sx={{ marginTop: -5, padding: 4 }}>
        <Typography sx={{ color: '#252733', fontWeight: "bold", marginBottom: "16px" }}>
          {intl.formatMessage({ id: 'FareMediaInfo' })}
        </Typography>

        {isFormLoading ? (
          <CircularProgress style={{ display: "block" }} />
        ) : (
          error != null ? <h4 style={{ textAlign: "center" }}>{intl.formatMessage({ id: 'somethingWrong' })}</h4> :
            <>
              <div className='table-view-item-info' style={{ width: "100%" }}>
                <div className="name-and-actions-btns-sec">
                  <h5 className="title-item-sec">
                    {fareMediaData.serial_num}
                  </h5>
                  <div className="actions-btns-sec">
                    {hasWriteAccess &&
                      <> <button className="styleAddBtn" style={{ position: "inherit", marginTop: "-10px", paddingBottom: "7px", paddingTop: "8px" }} onClick={() => history.push(`/CardsManagement/fareMedia/${id}/edit?came_from=one`)}>
                        <EditIcon style={{ fontSize: "24px", paddingRight: "3px", paddingLeft: "3px" }} /> {intl.formatMessage({ id: 'edit' })}
                      </button>
                      </>}

                  </div>
                </div>
                <div className="data-view-sec" style={{ display: "flex", justifyContent: "space-between" }}>
                  <div style={{ width: "35%" }}>
                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'uid' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.uid}
                      </div>
                    </div>
                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'serial_num' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.serial_num}
                      </div>
                    </div>
                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'parent_wallet_balance' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.wallet_balance} {intl.formatMessage({ id: 'currency' })}
                      </div>
                    </div>


                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'init_balance' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.init_balance} {intl.formatMessage({ id: 'currency' })}
                      </div>
                    </div>
                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'fare_media_type_name' })}
                      </div>
                      <div className="value-of-one-info">

                        {currentLanguageCode == "en-us" ? fareMediaData.en_fare_media_type_name : fareMediaData.ar_fare_media_type_name}
                      </div>
                    </div>
                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'issuer_name' })}
                      </div>
                      <div className="value-of-one-info">

                        {currentLanguageCode == "en-us" ? fareMediaData.en_issuer_name : fareMediaData.ar_issuer_name}
                      </div>
                    </div>
                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'org_name' })}
                      </div>
                      <div className="value-of-one-info">

                        {currentLanguageCode == "en-us" ? fareMediaData.en_org_name : fareMediaData.ar_org_name}
                      </div>
                    </div>


                    {fareMediaData.fm_user_id && <>  <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'user_name' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.user_name}
                      </div>
                    </div>
                      <div className="one-info">
                        <div className="title-of-one-info">
                          {intl.formatMessage({ id: 'user_email' })}
                        </div>
                        <div className="value-of-one-info">
                          {fareMediaData.user_email}
                        </div>
                      </div>
                      <div className="one-info">
                        <div className="title-of-one-info">
                          {intl.formatMessage({ id: 'user_phone' })}
                        </div>
                        <div className="value-of-one-info">
                          {fareMediaData.user_phone}
                        </div>
                      </div></>}
                      <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'is_blacklisted' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.is_blacklisted ? <> <CheckCircleIcon style={{ fontSize: "15px", marginTop: "-3px" }} /> {intl.formatMessage({ id: 'yes' })}</> : <> <DisabledByDefaultIcon style={{ fontSize: "15px", marginTop: "-3px" }} /> {intl.formatMessage({ id: 'no' })}</>}

                      </div>
                    </div>
                    {fareMediaData.is_blacklisted && <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'Blacklisted_note' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.blacklisted_note}
                      </div>
                    </div>}

                  </div>

                  <div style={{ width: "50%" }}>
                      <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'fare_media_batch_label' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.fare_media_batch_label || '-'}
                      </div>
                    </div>
                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'selling_price' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.selling_price ? parseFloat(fareMediaData.selling_price) : fareMediaData.selling_price} {intl.formatMessage({ id: 'currency' })}
                      </div>
                    </div>
                    <div className="one-info">
                      <div className="title-of-one-info" >
                        {intl.formatMessage({ id: 'is_sold' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.is_sold ? <> <CheckCircleIcon style={{ fontSize: "15px", marginTop: "-3px" }} /> {intl.formatMessage({ id: 'yes' })}</> : <> <DisabledByDefaultIcon style={{ fontSize: "15px", marginTop: "-3px" }} /> {intl.formatMessage({ id: 'no' })}</>}
                      </div>
                    </div>
                


                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'created_at' })}
                      </div>
                      <div className="value-of-one-info">
                        {convertToLocalTime(fareMediaData.created_at)} <EventNoteIcon style={{ fontSize: "15px", marginTop: "-3px" }} />
                      </div>
                    </div>

                    {/* <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'updated_at' })}
                      </div>
                      <div className="value-of-one-info">
                        {convertToLocalTime(fareMediaData.updated_at)} <EventNoteIcon style={{ fontSize: "15px", marginTop: "-3px" }} />
                      </div>
                    </div>*/}
                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'expiration_date' })}
                      </div>
                      <div className="value-of-one-info">
                        {convertToLocalTime(fareMediaData.expiration_date)} <EventNoteIcon style={{ fontSize: "15px", marginTop: "-3px" }} />
                      </div>
                    </div>
                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'issuing_date' })}
                      </div>
                      <div className="value-of-one-info">
                        {convertToLocalTime(fareMediaData.issuing_date)} <EventNoteIcon style={{ fontSize: "15px", marginTop: "-3px" }} />
                      </div>
                    </div>
                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'distribution_date' })}
                      </div>
                      <div className="value-of-one-info">
                        {convertToLocalTime(fareMediaData.distribution_date)} <EventNoteIcon style={{ fontSize: "15px", marginTop: "-3px" }} />
                      </div>
                    </div>

                    {/*<div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'total_charging_amount' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.total_charging_amount} {intl.formatMessage({ id: 'currency' })}
                      </div>
                    </div>*/}

                    {/*<div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'total_ticketing_amount' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.total_ticketing_amount} {intl.formatMessage({ id: 'currency' })}
                      </div>
                    </div>*/}
                    {/*userPersonalData.is_super_admin && <> 
                    <div className="one-info">
                      <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'calculated_balance' })}
                      </div>
                      <div className="value-of-one-info">
                        {fareMediaData.calculated_balance} {intl.formatMessage({ id: 'currency' })}
                      </div>
                    </div>
                      <div className="one-info">
                        <div className="title-of-one-info">
                          {intl.formatMessage({ id: 'BalanceNotes' })}
                        </div>
                        <div className="value-of-one-info">
                          {
                            fareMediaData.balance_diff > 0 ?
                              <span style={{ color: "black", fontWeight: "bold" }}>{intl.formatMessage({ id: 'addToFareMediaBalance' })} {fareMediaData.balance_diff} {intl.formatMessage({ id: 'currency' })} </span> :
                              fareMediaData.balance_diff < 0 ?
                                <span style={{ color: "red", fontWeight: "bold" }}>{intl.formatMessage({ id: 'removeFareMediaBalance' })} {fareMediaData.balance_diff}  {intl.formatMessage({ id: 'currency' })} </span> :
                                <span style={{ color: "green", fontWeight: "bold" }}>{intl.formatMessage({ id: 'BalanceIsCorrect' })} </span>
                          }
                        </div>
                      </div></>*/}
                  </div>

                </div>
                <div className="transactions-sec">
                  {fareMediaData && fareMediaData.id ? (
                    <>
                      <TransactionTabs tabsValue={tabsValue} handleChangeTabs={handleChangeTabs} />
                      {(tabsValue < 3 || tabsValue == 5) && (
                        <TableLimitPaginationFilter
                          page={page}
                          pageCount={pageCount}
                          limit={limit}
                          handlePrevious={handlePrevious}
                          handleNext={handleNext}
                          handleChangeLimit={handleChangeLimit}
                          rightContent={
                            <TableFilter
                              isFilterClicked={isFilterClicked}
                              filterStartDateValue={filterStartDateValue}
                              clearFilterResultOnly={clearFilterResultOnly}
                              transactions={transactions}
                              filterPopoverClickButton={filterPopoverClickButton}
                              idOfPopUp={idOfPopUp}
                              open={open}
                              anchorEl={anchorEl}
                              handleClose={handleClose}
                              runDateTimeFilter={runDateTimeFilter}
                              startDate={startDate}
                              setStartDate={setStartDate}
                              endDate={endDate}
                              setEndDate={setEndDate}
                            />
                          }
                          transactions={transactions}
                        />
                      ) }

                      {(tabsValue < 3 || tabsValue == 5) && transactions?.length > 0 ? <TableStatistics
                        transactionsNumber={transactionsNumber}
                        transactionsTotalAmount={transactionsTotalAmount}
                        transactionsTotalCredits={transactionsTotalCredits}
                        transactionsTotalDebits={transactionsTotalDebits}

                      /> : <></>}

                      <div className="parentTable-customer-support">
                        {tabsValue == 1 ?
                          <TicketsTranscTable transactions={transactions} isLoading={isLoading} convertToLocalTime={convertToLocalTime} tabsValue={tabsValue} />
                          : tabsValue == 2 ?
                            <ChargingTranscTable transactions={transactions} isLoading={isLoading} convertToFormattedUTC={convertToFormattedUTC} tabsValue={tabsValue} />
                          : tabsValue == 5 ?
                            <FmSellingTable transactions={transactions} isLoading={isLoading} convertToLocalTime={convertToLocalTime} />
                          : tabsValue == 6 ?
                            <FmOffersTable 
                              transactions={transactions} 
                              isLoading={isLoading} 
                              convertToLocalTime={convertToLocalTime} 
                              fareMediaId={id}
                              fareMediaBalance={fareMediaData?.wallet_balance}
                              onRefresh={() => fareMediaData && fetchFareMedia()}
                              hasWriteAccess={hasWriteAccess}
                              userPhone={fareMediaData?.user_phone}
                            />
                          : <BothTranscTable transactions={transactions} isLoading={isLoading} convertToLocalTime={convertToLocalTime} displayedTotalAmount={displayedTotalAmount}
                              displayedTotalCredits={displayedTotalCredits}
                              displayedTotalDebits={displayedTotalDebits}
                              transactionsTotalCredits={transactionsTotalCredits}
                              transactionsTotalDebits={transactionsTotalDebits} />
                        }
                      </div>

                    </>) : <></>}
                </div>
              </div>

            </>
        )}
        <button
          className='cancelBtnStyle'
          style={{ marginTop: "20px" }}
          onClick={() => history.push(`/CardsManagement/fareMedia/`)}
        >
          {intl.formatMessage({ id: 'Back' })}
        </button>
      </Box>
      <ToastContainer /></>

  );
};

export default ViewFareMedia;
